import React from 'react';
import { Popover, UnstyledButton, useMantineTheme } from '@mantine/core';
import { IconMoodSmile } from '@tabler/icons-react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import i18n from '@emoji-mart/data/i18n/es.json'

const EmojiPopover = ({ onSelect }) => {

	// State and hooks
	const theme = useMantineTheme();

	return (
		<Popover
			// width={400}
			position="bottom-end"
			withArrow
			shadow="md"
			withinPortal
		>
			{/* Opener */}
			<Popover.Target>
				{/* Icon */}
				<UnstyledButton pt={5}>
					<IconMoodSmile
						size="1.2rem"
						stroke={2}
						color={theme.colorScheme === 'dark' ? 'white' : theme.colors.mainPurple[4]}
					/>
				</UnstyledButton>
			</Popover.Target>
			{/* Content */}
			<Popover.Dropdown>
				{/* Emoji */}
				<Picker
					data={data}
					onEmojiSelect={onSelect}
					theme={theme.colorScheme}
					skinTonePosition="none"
					searchPosition="none"
					previewPosition="none"
					i18n={i18n}
				/>
			</Popover.Dropdown>
		</Popover>
	);

}

export default EmojiPopover;
